export const FOODIT_LOCALSTORAGE = {
  LANGUAGE: 'FOODit.restaurant.language',
  BASKET_UUID: 'FOODit.restaurant.basketUuid',
  CHECKOUT_DATA: 'FOODit.basket.checkoutData',
  OVERRIDE_CASH_PAYMENT: 'FOODit.checkout.OVERRIDE_CASH_PAYMENT',
  ORDER_FAILED: 'FOODit.checkout.ORDER_FAILED'
};

export const CLOSED = 'CLOSED';

// ANALYTICS
export const ANALYTICS_EVENTS = {
  ADD_MEAL_TO_BASKET_CLICKED: 'ADD_MEAL_TO_BASKET_CLICKED',
  GALLERY_MEAL_CARD_CLICKED: 'GALLERY_MEAL_CARD_CLICKED',
  CHANGED_LANGUAGE: 'CHANGED_LANGUAGE',
  ADD_PRODUCT: 'Add Product',
  ADD_PRODUCT_FROM_UPSELL: 'Add Product from upsell',
  REMOVE_PRODUCT: 'Remove Product',
  PURCHASE: 'Purchase',
  CONFIRM_ORDER: 'Confirm Order',
  START_PAYMENT: 'Start Payment',
  UPSELL_CHECKOUT: 'Checkout from upsell',
  UPSELL_OPEN: 'Upsell opened',
  UPSELL_CLOSE: 'Upsell closed'
};

export const ITEM_ORIGIN = {
  UPSELL: 'UPSELL',
  HOME: 'HOME',
  MENU: 'MENU'
};

export const ORDER_SOURCE = {
  CENTRAL_DISH: 'CD'
};

export const ANALYTICS_EVENT_CATEGORIES = {
  MENU: 'MENU',
  SETTINGS: 'SETTINGS',
  SHOPPING_CART: 'ShoppingCart',
  JAVASCRIPT_ERROR: 'JavaScript Error',
  UPSELL: 'UPSELL'
};

export const ANALYTICS_EC = {
  EC: 'ec',
  EC_PREFIX: 'ec:',
  EC_ADD_PRODUCT: 'addProduct',
  EC_SET_ACTION: 'setAction',
  EC_ADD_ACTION: 'add',
  EC_REMOVE_ACTION: 'remove',
  EC_PURCHASE: 'purchase',
  EC_CHECKOUT: 'checkout',
  EC_ADD_IMPRESSION: 'addImpression'
};

export const ANALYTICS_DIMENSIONS = {
  RESTAURANT_CODE_DIMENSION: 'dimension1'
};

// SUPPORTED_CURRENCIES
export const SUPPORTED_CURRENCIES = {
  GBP: {
    code: 'GPB',
    symbol: '£'
  },
  EUR: {
    code: 'EUR',
    symbol: '€'
  },
  USD: {
    code: 'USD',
    symbol: '$'
  }
};

export const BASKET_MODE = {
  EDIT: 'EDIT',
  CREATE: 'CREATE'
};

export const PAYMENT_TYPES = {
  CASH: 'CASH',
  PAYPAL: 'PAYPAL',
  CREDIT_CARD: 'CREDIT_CARD'
};

// PAGES AND URLS
export const PAGES = {
  CHECKOUT: 'checkout',
  MENU: 'menu',
  CONFIRMATION: 'confirmation'
};

export const STATUSES = {
  STATUS: 'status',
  SUBMITTED: 'submitted',
  PAYMENT_FAILED: 'paymentfailed'
};

export const FOODITWEBSITE = {
  URL: 'https://foodit.com/'
};

export const SERVICE_TYPE = {
  DELIVERY: 'delivery',
  COLLECTION: 'collection'
};

export const GOOGLE_MAP_API_KEY = 'AIzaSyBTiYhq_EeFv4_KpX1KkN5iXhzhdbD2cLk';

export const DEFAULT_HEADER_COLOR = '#000';

export const DEFAULT_DATE_FORMAT = 'D MMMM, YYYY';
export const DEFAULT_TRACKER_TIME_FORMAT = 'h:mm A';
export const DEFAULT_TRACKER_FUTURE_TIME_FORMAT = 'dddd D MMMM, YYYY h:mm A';

export const TRIP_ADVISOR_URI = 'https://www.tripadvisor.com/WidgetEmbed-selfserveprop?writereviewlink=true&rating=true&border=false&uniq=870&iswide=true&lang=en_UK&nreviews=4&display_version=2';

export const ORDER_STATUS = {
  ORDERED: 'ORDERED',
  CONFIRMED: 'CONFIRMED',
  PREPARING: 'PREPARING',
  COOKING: 'COOKING',
  READY: 'READY',
  COMPLETED: 'COMPLETED',
  CANCELLATION_PENDING: 'CANCELLATION_PENDING',
  CANCELLED: 'CANCELLED'
};

export const ORDER_TRACKER_STEPS = [
  'ORDERED',
  'CONFIRMED',
  'READY',
  'COMPLETED',
  'CANCELLATION_PENDING',
  'CANCELLED'
];

export const PROMOTION_TYPES = {
  FREE_MEAL: 'FREE_MEAL',
  DISCOUNT: 'DISCOUNT',
  VOUCHER: 'VOUCHER',
  SURCHARGE: 'SURCHARGE'
};

export const FIREBASE_DB = {
  ORDER_TRACKER: 'order-tracker',
  GA_TRACKER: 'ga-tracker'
};

// CHECKOUT FORM
export const MINIMUM_FIELD_LENGTH = 3;

export const UPSELLING_EXCLUDED_CATEGORIES = [
  'kid',
  'child',
  'alco',
  'cocktai',
  'spirit',
  'wine',
  'beer',
  'champagne',
  'liqu',
  'sake',
  'misc',
  'cigs',
  'cigar',
  'brandy',
  'bubbly',
  'cider',
  'groceries'
];

// FEEDBACK FORM

export const FEEDBACK = {
  WOULD_ORDER_AGAIN: 'WOULD_ORDER_AGAIN',
  MAYBE_ORDER_AGAIN: 'MAYBE_ORDER_AGAIN',
  WOULD_NOT_ORDER_AGAIN: 'WOULD_NOT_ORDER_AGAIN'
};

export const REVIEW_OPTIONS = {
  FLAVOUR: 'Flavour',
  FRESHNESS: 'Freshness',
  TEXTURE: 'Texture',
  AROMA: 'Aroma',
  PRESENTATION: 'Presentation',
  PORTION_SIZE: 'Portion size',
  QUALITY_OF_INGREDIENTS: 'Quality of ingredients',
  VALUE_FOR_MONEY: 'Value for money',
  HEALTHY: 'Healthiness',
  AUTHENTICITY: 'Authenticity',
  SPICY: 'Spiciness',
  ORIGINALITY: 'Originality',
  NUTRITIONAL_QUALITY: 'Nutritional quality',
  COOKED_TO_YOUR_LIKING: 'Cooked to your liking'
};

export const FEEDBACK_STATUS = {
  COMPLETED: 'COMPLETED',
  AUTO_CLOSED: 'AUTO_CLOSED'
};

export const MAX_CHOSEN_QUALITIES = 3;

export const BLOCK_TYPES = {
  PIC: 'Pictext',
  DISHES: '3dish',
  ICONS: '3icon'
};

export const FINGERPRINT_INIT_TIME_MS = 1000;

export const ONLINE_ORDER_PERMANENTLY_DISABLED = {
  'harringtonsfishchipsrestaurant': true
};

export const DINE_COMMENT = 'Dine In Table Number is';

export const URL_QUERY_PARAMS = {
  TABLE_ID: 'tableId',
  ERROR: 'error',
  MEAL_UUID: 'mealUuid'
};



// WEBPACK FOOTER //
// ./constants/constant.js